export const FETCH_ACTIVE_STUDENT_TYPES = 'FETCH_ACTIVE_STUDENT_TYPES';
